<template>
  <div class="search-empty">
    <img class="search-empty-pic" :src="noResultPng" alt="无搜索结果" />
    <p class="search-empty-title">无搜索结果</p>
    <p class="search-empty-tips">一键提交，让小编为您加速上架</p>
    <button class="search-empty-btn" @click="submitFeedback">
      快马加鞭做起来
    </button>
  </div>
</template>

<script>
import noResultPng from '@/assets/image/no-result.png';

export default {
  data() {
    return {
      hash: '',
      noResultPng,
    };
  },

  props: {
    fromChannel: Number,
    keyword: String,
  },

  methods: {
    async submitFeedback() {
      const { keyword, fromChannel } = this;

      // 上报搜索无结果
      this.$collect.searchpageResultClick({
        click: 'noresult',
        searchkey: this.keyword,
      });

      if (!this.hash) {
        this.hash = await this.$service.learning.getFbToken().catch(() => '');
      }

      this.$service.learning
        .submitFeedback({
          feedback: keyword,
          fromChannel,
          hash: this.hash,
        })
        .then((res) => {
          const msg = res.msg;
          let icon = 'iconic_smile';

          if (res && res.code === 200) {
            icon = 'iconic_success';
          }

          this.$toast(msg, icon, 3000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-empty {
  padding: 100px 0;
  @include flex-align-center();
  flex-direction: column;

  &-pic {
    width: 144px;
    margin-bottom: 4px;
  }

  &-title {
    margin-bottom: 10px;
  }
  &-tips {
    font-size: 12px;
    color: #999999;
    margin-bottom: 20px;
  }

  &-btn {
    width: 197px;
    height: 34px;
    border-radius: 17px;
    outline: none;
    border: none;
    background: #417ff9;
    color: #fff;
    cursor: pointer;

    &:hover {
      background: #5d92f9;
    }

    &:active {
      background: #376cd3;
    }
  }
}
</style>